import React, { Component } from 'react'
import PropTypes from "prop-types";
// import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { getVisibleProjects, receiveProject } from '../../modules/projects'

import { push } from 'react-router-redux';
import APIRequest from '../../helpers/APIRequest'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

// import DashbordIcon from 'react-icons/lib/fa/dashboard'
// import ListIcon from 'react-icons/lib/fa/list'
import FolderdIcon from 'react-icons/lib/fa/folder'
// import FolderdOpenIcon from 'react-icons/lib/fa/folder-open'
// import ShareAlt from 'react-icons/lib/fa/share-alt'
import { getFormula } from '../../helpers/lib'
// import MdInsertDriveFile from 'react-icons/lib/md/extension'
import MdDashboard from 'react-icons/lib/md/dashboard'
import FolderIcon from 'react-icons/lib/md/folder-open'
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";


import './sidebar.css'

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalNewProject: false
    };
    this.toggleNewProjectModal = this.toggleNewProjectModal.bind(this);
  }

  toggleNewProjectModal(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({
      modalNewProject: !this.state.modalNewProject
    });
  }

  addProject(event) {
    event.preventDefault();
    const name = event.target.inputChangeName.value.trim();
    APIRequest.post(`projects`, {name}).then(res => {
      this.props.receiveProject(res.data);
      this.toggleNewProjectModal();
      this.props.push(`/projects/${res.data._id}`);
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    });
  }

  render() {
    const { projects = [] } = this.props;
    return (
      <div className="sidebar bg-dark">
        <nav className="sidebar-nav">
          <ul className="nav">
            <li className="nav-item">
              <NavLink exact className="nav-link" to="/"><MdDashboard className="sidebar-icon"/> Dashboard</NavLink>
            </li>
            <li className="nav-item nav-dropdown">
              <a className="text-decoration-none text-white p-3 first-step" href="#newProject" onClick={this.toggleNewProjectModal} style={{position:'absolute', right:'0', top:'0', zIndex:1}}><span className="icon-plus icons"/></a>
              <NavLink className="nav-link nav-dropdown-toggle" to="/projects">
                <FolderIcon className="sidebar-icon sidebar-icon-close"/>
                <FolderdIcon className="sidebar-icon sidebar-icon-open"/>Projects</NavLink>
              <ul className="nav nav-dropdown-items collapse">
                {projects.sort((a, b) => {
                  return new Date(b.createdAt) - new Date(a.createdAt);
                }).map((project, index) => (
                  <li key={index} className="nav-item nav-dropdown">
                    <NavLink className="nav-link" to={`/projects/${project._id}`}>
                      <FolderIcon className="sidebar-icon sidebar-icon-close"/><FolderIcon className="sidebar-icon sidebar-icon-open"/> {getFormula(project.name)}
                    </NavLink>
                    {/* <ul className="nav nav-dropdown-items collapse nav-items-2">
                        {project.structures && project.structures.map((structure, i) => (
                        <li key={i} className="nav-item">
                        <NavLink className="nav-link" to={`/projects/${project._id}/structures/${structure._id}`}>
                        <ShareAlt className="sidebar-icon"/> {structure.name}
                        </NavLink>
                        </li>
                        ))}
                    </ul> */}
                  </li>
                ))}
              </ul>
            </li>
            {/*<li className="nav-item">
              <NavLink exact className="nav-link" to="/calculations"><ListIcon className="sidebar-icon"/> Calculations</NavLink>
            </li>*/}
          </ul>
        </nav>
        <Modal isOpen={this.state.modalNewProject} toggle={this.toggleNewProjectModal}>
          <form onSubmit={this.addProject.bind(this)}>
            <ModalHeader toggle={this.toggleNewProjectModal}>Create a new project</ModalHeader>
            <ModalBody>
              <label>Choose a name</label>
              <input type="text" id="inputChangeName" className="form-control" placeholder="New project" required="required"/>
            </ModalBody>
            <ModalFooter>
              <Button type="submit" color="primary">Create the project</Button>{' '}
              <Button color="secondary" onClick={this.toggleNewProjectModal}>Cancel</Button>
            </ModalFooter>
          </form>
         </Modal>
      </div>

     /* Modal Create New Project */

    )
  }
}

Sidebar.contextTypes = {
  joyrideProvider: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
  user: state.user.user,
  projects: getVisibleProjects(state.projects)
})

const mapDispatchToProps = dispatch => bindActionCreators({
  receiveProject,
  push
}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sidebar))



// WEBPACK FOOTER //
// ./src/containers/sidebar/index.js